import { CartModificationPayload } from '@cart/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { DIFFS } from '../cart-state';

export const LOAD_DIFF = '[CustomCart] Load diff';
export const LOAD_DIFF_FAIL = '[CustomCart] Load diff Fail';
export const LOAD_DIFF_SUCCESS = '[CustomCart] Load diff Success';
export const CONFIRM_DIFF = '[CustomCart] Confirm cart difference';
export const VALIDATE_CART = '[CustomCart] validate cart';

export class LoadDiff extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_DIFF;

  constructor(public payload: string) {
    super(DIFFS);
  }
}

export class LoadDiffFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_DIFF_FAIL;

  constructor(public payload: any) {
    super(DIFFS, payload);
  }
}

export class LoadDiffSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_DIFF_SUCCESS;

  constructor(public payload: CartModificationPayload) {
    super(DIFFS);
  }
}

export class ConfirmDiff implements Action {
  readonly type = CONFIRM_DIFF;

  constructor(public payload: string) {}
}

export class ValidateCart implements Action {
  readonly type = VALIDATE_CART;
}

export type CartDiffActions = LoadDiff | LoadDiffSuccess | LoadDiffFail | ConfirmDiff | ValidateCart;
